import React from 'react'

function UserOrders() {
  return (
    <div>UserOrders</div>
  )
}

export default UserOrders